import script from "./CallbackView.vue?vue&type=script&setup=true&lang=js"
export * from "./CallbackView.vue?vue&type=script&setup=true&lang=js"

import "./CallbackView.vue?vue&type=style&index=0&id=40aae23a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40aae23a"]])

export default __exports__